import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import * as directives from "@/directives";
import i18n from "@/locales/index";
import { setAppDeviceCookieIfAbsent } from "@/modules/common.ts";
import { createHead } from "@unhead/vue";
import "animate.css";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import { Lazyload } from "vant";
import "vant/lib/index.css";
import { registerSW } from "virtual:pwa-register";
import "./assets/main.css";
import { StorageGet } from "./tools/localStorage";
import { sessionStorageRemove } from "./tools/sessionStorage";
import { useGlobalUser } from "@/stores/globalUser";

// 注册PWA 且 在完成Cache更新后立即刷新页面
// （不加这一行的话后台仅会更新ServiceWorker, 而页面在下次刷新前会仍然以缓存中的旧版本展示）
registerSW({ immediate: true });
if (import.meta.env.DEV || import.meta.env.VITE_SHOW_DEBUG_TOOL) {
  import("vconsole").then(({ default: VConsole }) => {
    new VConsole();
  });
}

const app = createApp(App);

app.config.globalProperties.$t = i18n.global.t;
const pinia = createPinia();
app.use(pinia);

async function initLogin() {
  // 等待登录态初始化完成后再安装路由，避免基于默认 isLogin 的提前跳转
  try {
    await useGlobalUser(pinia).init();
  } catch (e) {
    // 忽略，后续在 App.vue 中有兜底处理
  }
}

initLogin().then(() => {
  app.use(router);
  window.$router = router;
  app.use(i18n);
  app.use(Lazyload, {
    lazyComponent: true,
  });
  const head = createHead();
  app.use(head);
  app.use(FloatingVue, {
    themes: {
      tooltip: {
        triggers: ["hover", "focus", "touch", "click"],
      },
    },
  });
  document.documentElement.setAttribute(
    "data-theme",
    StorageGet("theme") || "auto"
  );

  setAppDeviceCookieIfAbsent();

  Object.keys(directives).forEach((key) => app.directive(key, directives[key]));

  window.addEventListener("beforeunload", function () {
    // 模拟登录的时候，cache中会缓存user，在退出模拟的时候，需要清除
    sessionStorageRemove("user");
  });
  app.mount("#app");
});
